/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface AiModels
 */
export interface AiModels {
  /**
   *
   * @type {number}
   * @memberof AiModels
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AiModels
   */
  name: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof AiModels
   */
  taskType?: TaskTypeEnum;
}

/**
 * Check if a given object implements the AiModels interface.
 */
export function instanceOfAiModels(value: object): value is AiModels {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function AiModelsFromJSON(json: any): AiModels {
  return AiModelsFromJSONTyped(json, false);
}

export function AiModelsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModels {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
  };
}

export function AiModelsToJSON(value?: Omit<AiModels, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
